<app-modal [title]="'Detalles del servicio'" [loading]="loading">
      <app-form [formGroup]="editForm">
        <div class="mb-5">
          <app-label for="param_servicio_id">
            Servicio
          </app-label>
          <app-select id="param_servicio_id" formControlName="param_servicio_id" placeholder="Seleccione un servicio" [options]="serviciosOptions" />
        </div>
      </app-form>

      <div class="flex justify-end gap-2 mt-6">
        <app-button
          variant="outline"
          (btnClick)="close()"
        >
          Cerrar
        </app-button>
      </div>
</app-modal>
